module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAABHNCSVQICAgIfAhkiAAAAMRJREFUKJF9UkEOgzAMs6s9CMYeAC8DXka50zU/8g6lLEMMS5WqyHUcN8QFmuY5gpwARACAOJtt0XN4IveFqGj2nkv91YMazwI81KWpkq9deAHFsHeJQFj/PQIAsy1CKofseVIrIqeZvCuQk+XE3xlr12qpQtpFwgpqtJyG8I2JpSu1HEHkNOzWpkNQnAEgeGHLabCcCHEGNTZtt+x1/g2uku7gOeGOeIfHcZNi03bL1ZaU4OBCcptTCO6Ty9cAQPSbVPEBwVZ6vayirlEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sendlasohi.png
// module id = NBP9
// module chunks = 1